const styles = theme => ({
    root: {
        padding: 0,
        overflow: 'hidden',
        opacity: 0.99,
        zIndex: 9999999999
    },
    mask: {
        position: 'absolute',
        top: 0,
        left: 0,
        right: 0,
        width: '100%',
        height: '100%',
        display: 'block',
        backgroundColor: theme.palette.background.paper,
        opacity: 1
    },
    contentRoot: {
        textAlign: 'center',
        height: '50vh',
        overflow: 'hidden',
        marginTop: '25%',
        zIndex: 2,
        backgroundColor: theme.palette.background.paper,
        opacity: 0.7
    },
    message: {
        padding: theme.spacing(4),
        marginLeft: 'auto',
        marginRight: 'auto',
        borderRadius: 5
    },

    messageText: {
        color: theme.palette.text.primary,
    }
});

export default styles;